import {SET_LANGUAGE, SET_PAGE_TITLE, UPDATE_THEME_SETTINGS} from '../actionTypes'



/**
 * Redux Action To Set Language
 */
export const setLanguage = (language) => ({
    type: SET_LANGUAGE,
    payload: language,

});

// set page title
export const setPageTitle = (title, setting) => ({
    type: SET_PAGE_TITLE,
    payload: title,
    setting: setting
});
